import { useEffect, useState } from 'react'

import { cn } from '@/lib/cn'

interface PromotionProps {
  className?: string
}

export default function PromoPopup(className: PromotionProps) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 5000)
    return () => clearTimeout(timer)
  }, [])

  if (!isVisible) return null

  return (
    <div
      className={cn(
        'fixed inset-0 z-[9999] flex hidden items-center justify-center bg-black bg-opacity-30 p-4',
        className
      )}
    >
      <div className="relative w-full max-w-[95vw] overflow-hidden rounded-2xl bg-transparent lg:max-w-[80vw] xl:max-w-[70vw] 2xl:max-w-[60vw]">
        <button
          className="absolute right-2 top-2 z-10 text-2xl font-bold text-white hover:text-gray-300"
          onClick={() => setIsVisible(false)}
        >
          &times;
        </button>
        <img
          src="https://academy-r2-statics.bitlabs.id/popup%20promotion%20japan.png"
          alt="Promo Japan"
          className="h-auto w-full cursor-pointer object-cover"
          onClick={() => {
            window.open('https://challenge.yes.co.id/', '_blank')
            setIsVisible(false)
          }}
        />
      </div>
    </div>
  )
}
